import { useAutoClaimRewards } from "@/hooks/use-auto-claim-rewards";

/**
 * App-wide auto-claim of daily-challenge rewards.
 *
 * Renders nothing — it exists so the side effect can be mounted once, high in
 * the tree, next to the toast layer it talks to. Mounting it here rather than
 * in a page means the reward lands no matter which surface the learner was on
 * when they completed the challenge.
 */
export const AutoClaimRewards = () => {
    useAutoClaimRewards();
    return null;
};
